import { h } from "@stencil/core";
/**
 * Parses a string to HTML nodes.
 * @param content - The string to parse.
 * @returns The HTML nodes.
 */
export function parseStringToHtmlNodes(content) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    /**
     * Get all attributes of an element.
     * @param element
     */
    const getAttributes = (element) => {
        const attrs = {};
        Array.from(element.attributes).forEach((attr) => {
            attrs[attr.name] = attr.value;
        });
        return attrs;
    };
    /**
     * Create a DOM element from a list of nodes – recursively.
     * @param nodes
     */
    const createElementFromNodes = (nodes) => {
        const elements = [];
        nodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                elements.push(node.textContent);
            }
            else if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node;
                elements.push(h(element.tagName.toLowerCase(), Object.assign({}, getAttributes(element)), createElementFromNodes(element.childNodes)));
            }
        });
        return elements;
    };
    return createElementFromNodes(doc.body.childNodes);
}
//# sourceMappingURL=utils.js.map
